import React from "react";
import Tag from "../Tag";
import styled from "styled-components";
import { MobileView } from "react-device-detect";
import { ReactComponent as ArrowIcon } from "../../img/icons/arrowdown.svg";

const LiveInformationsStyled = styled.div`
  max-width: 363px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  min-height: 310px;
  max-height: 310px;
  > *:not(last-child) {
    margin-bottom: 12px;
  }
  z-index: 2;
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0;
  }
  @media only screen and (max-width: 1200px) {
    max-width: 300px;
  }
  @media only screen and (max-width: 1100px) {
    max-width: 260px;
  }
  @media only screen and (max-width: 992px) {
    margin-top: 20px;

    width: 100%;
    max-width: 100%;
    flex-direction: column;
  }
  @media only screen and (max-width: 522px) {
    margin-top: 20px;
    height: auto;
    min-height: 170px;
    max-height: 310px;
  }
`;
const Header = styled.div`
  min-width: 300px;
  flex-direction: column;
  @media only screen and (max-width: 992px) {
    min-width: 100%;
    flex-direction: column;
  }
`;
const Avatar = styled.img`
  margin-right: 15px;
  width: 77px;
  min-width: 77px;

  height: 77px;
  border-radius: 10px;
  object-fit: cover;
`;
const Top = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 90%;

  @media only screen and (max-width: 992px) {
    width: 100%;
  }

  #test {
    flex: 1;
  }
`;
const Views = styled.p`
  margin-top: 6px;
`;
const Title = styled.h4`
  font-size: 25px;
  color: ${({ theme }) => theme.color.darkerText};
  margin-left: 5px;
  @media only screen and (max-width: 522px) {
    font-size: 15px;
  }
`;
const UserName = styled.h5`
  font-size: 15px;
  margin-left: 5px;

  @media only screen and (max-width: 522px) {
    font-size: 14px;
  }
`;
const Tags = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  @media only screen and (max-width: 992px) {
    margin-top: 15px;
  }
`;
const Description = styled.div`
  width: 100%;
  min-height: 123px;
  margin-top: 3px;
  @media only screen and (max-width: 992px) {
    max-height: 90px;
    min-height: 10px;
    height: auto;
  }
`;
const DesctriptiveText = styled.p`
  @media only screen and (max-width: 1200px) {
    font-size: 12px;
  }
  @media only screen and (max-width: 992px) {
    font-size: 16px;
  }
  @media only screen and (max-width: 769px) {
    font-size: 12px;
  }
`;
const EventBadge = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: ${({ theme }) => theme.color.primaryText};
  a {
    color: ${({ theme }) => theme.color.primary };
    text-decoration: none;
  }
`;
const NavigationButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 9.64px;
  @media only screen and (max-width: 522px) {
    flex-direction: column-reverse;
  }

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 41.36px;
    height: 41.36px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.color.secondaryBg};
    cursor: pointer;
    transition: transform 200ms;
    img {
      path {
        fill: ${({ theme }) => theme.color.primaryText};
      }
    }
    :hover {
      transition: transform 200ms;
      transform: scale(1.07);
    }
    :nth-child(1) {
      svg {
        transform: rotate(90deg);
      }
    }
    :nth-child(2) {
      svg {
        transform: rotate(-90deg);
      }
    }
    @media only screen and (max-width: 522px) {
      flex-direction: column;
      :nth-child(1) {
        svg {
          transform: rotate(360deg);
        }
      }
      :nth-child(2) {
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  @media only screen and (max-width: 992px) {
    margin-bottom: 20px;
  }
`;
export default function LiveInformations({ lives, live, index, setIndex, isLoading }) {
  const watchTarget = live?.watchTarget || (live?.username ? `/stream/${live.username}` : "#");

  function move(i) {
    if (i === 1) {
      if (index === 0) {
        setIndex(lives.length - 1);
        return;
      }
      setIndex(index - 1);
    } else {
      if (index === lives.length - 1) {
        setIndex(0);
        return;
      }
      setIndex(index + 1);
    }
  }
  return (
    <LiveInformationsStyled>
      <Header>
        <Top>
          {isLoading ? (
            <Avatar></Avatar>
          ) : (
            <a href={live?.username ? ("/profile/" + live.username) : "#"}>
              <Avatar src={live?.avatar} alt="title" />
            </a>
          )}
          <div style={{ height: "100%" }}>
            <a href={watchTarget}>
              <Title>{live?.title}</Title>
            </a>
            {live?.linkedEvent && (
              <EventBadge>
                📅 Event en cours:&nbsp;
                <a href={`/events/${live.linkedEvent.slug}`}>
                  {live.linkedEvent.name}
                </a>
              </EventBadge>
            )}

            <UserName>{live?.username}</UserName>
            <Views>
              {live?.linkedEvent?.category ||
                live?.stream_games?.name ||
                live?.game?.name ||
                live?.game ||
                "Gaming"}
            </Views>
          </div>
          <MobileView id="test">
            <NavigationButtons>
              <div
                onClick={() => {
                  move(-1);
                }}
              >
                <ArrowIcon />
              </div>
              <div
                onClick={() => {
                  move(1);
                }}
              >
                <ArrowIcon />
              </div>
            </NavigationButtons>
          </MobileView>
        </Top>
      <Tags>
  {(() => {
    try {
      console.log('🏷️ Tags data:', live?.tags, 'Type:', typeof live?.tags);
      const tags = live?.tags;
      if (!tags) return [];
      if (Array.isArray(tags)) return tags;
      if (typeof tags === 'string') return [tags];
      if (typeof tags === 'object' && tags.length !== undefined) return Array.from(tags);
      return [];
    } catch (error) {
      console.error('❌ Error processing tags:', error);
      return [];
    }
  })().map((tag, index) => (
    <Tag key={index} to={"/tag/" + tag}>
      {tag}
    </Tag>
  ))}
</Tags>

      </Header>
      <Description>
        {live?.about && (
          <DesctriptiveText>{live?.about.substring(0, 230).concat(" ...")}</DesctriptiveText>
        )}
      </Description>
    </LiveInformationsStyled>
  );
}
